module.exports = __webpack_public_path__ + "static/media/info_email.91b5fc08.svg";